import { createContext } from "react";
const HeadlessFieldsContext = createContext<boolean>(false);
export default HeadlessFieldsContext;
